function DataLabel(props:any){
    const {children} = props;

    return <>
        <span className="text-sm text-gray-400 font-medium">{children}</span>
    </>;
}

export default DataLabel;